module.exports = __webpack_public_path__ + "img/29.010556c0.svg";